import { Button, Col, DatePicker, Form, Row } from "antd";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useRef, useState } from "react";
import { HiOutlineFilter } from "react-icons/hi";
import { TfiReload } from "react-icons/tfi";
import SelectAdd from "../inputAnt/selectAdd";

dayjs.extend(customParseFormat);

export default function FilterMembership({ handleManager }) {
	const formFilterRef = useRef(null);
	const [ngayBatDau, setNgayBatDau] = useState(null);
	const dateFormatList = ["DD/MM/YYYY"];

	const setFieldsValue = (name, value) => {
		formFilterRef.current?.setFieldsValue({ [name]: value });
	};

	const onFinish = (values) => {
		handleManager(values);
	};

	const onReset = () => {
		formFilterRef.current?.resetFields();
		setNgayBatDau(null);
	};

	return (
		<Form
			id="form-filter-report"
			ref={formFilterRef}
			name="control-ref"
			onFinish={onFinish}
			layout="vertical"
			labelCol={{ span: 4 }}
		>
			<div className="flex justify-between items-center">
				<span className="font-medium">Lọc và tìm kiếm</span>
				<Button
					shape="circle"
					size="small"
					className="btn_ternary !border-none"
					onClick={() => {
						onReset();
						handleManager({});
					}}
				>
					<TfiReload />
				</Button>
			</div>

			<div className="pt-4 h-fit max-h-[calc(100vh-150px)] overflow-y-auto">
				<Row gutter={[12, 12]} className="!m-0">
					{/* Hạng khách hàng */}
					<Col xs={24} sm={12}>
						<SelectAdd
							api="membership"
							label="Hạng khách hàng"
							name="ma_hang"
							lableOption={["name"]}
							valueOption={["code"]}
                    
							labelCol={{ span: 24 }}
							wrapperCol={{ span: 24 }}
							placeholder="Chọn hạng"
							className="w-full"
						/>
					</Col>

					{/* Ngày bắt đầu */}
					<Col xs={24} sm={12}>
						<Form.Item
							label="Ngày bắt đầu"
							name="tu_ngay"
							labelCol={{ span: 24 }}
							wrapperCol={{ span: 24 }}
							className="!mb-0"
						>
							<DatePicker
								placeholder="Chọn ngày bắt đầu"
								value={ngayBatDau}
								format={dateFormatList}
								onChange={(date) => {
									setNgayBatDau(date);
									setFieldsValue("tu_ngay", date);
								}}
								allowClear
								className="w-full"
							/>
						</Form.Item>
					</Col>
				</Row>
			</div>

			<div className="w-full justify-between flex items-center flex-row-reverse">
				<div className="flex justify-end items-center gap-4 p-2">
					<Button
						htmlType="submit"
						className="btn_ternary flex items-center gap-1"
					>
						<HiOutlineFilter />
						Lọc
					</Button>
				</div>
			</div>
		</Form>
	);
}
